import React, { useEffect, useState } from "react"
import { Wrapper } from "./Recyclopedia.styles"
import RecyclopediaForm from "../RecyclopediaForm/RecyclopediaForm"
import RecyclopediaResults from "../RecyclopediaResults/RecyclopediaResults"

const Recyclopedia = () => {
  const [searchTerm, setSearchTerm] = useState("")
  const [filters, setFilters] = useState([])
  const [resultCount, setResultCount] = useState(0)
  const [results, setResults] = useState([])

  useEffect(() => {}, [filters, resultCount, searchTerm])

  return (
    <Wrapper className="search-container">
      <RecyclopediaForm
        setSearchTerm={setSearchTerm}
        searchTerm={searchTerm}
        resultCount={resultCount}
        filters={filters}
        setFilters={setFilters}
      />
      {searchTerm && (
        <RecyclopediaResults
          searchTerm={searchTerm}
          resultCount={resultCount}
          setResultCount={setResultCount}
          filters={filters}
          results={results}
          setResults={setResults}
        />
      )}
    </Wrapper>
  )
}
export default Recyclopedia
